export const getDefaultTitles = () => {
    const titles = [
        {
            title: "Birthday",
            sectionTitle: "",
            sectionSubTitle: "",
            navbarTitle: ""
        },
        {
            title: "Live",
            sectionTitle: "",
            sectionSubTitle: "",
            navbarTitle: ""
        },
        {
            title: "Story",
            sectionTitle: "",
            sectionSubTitle: "",
            navbarTitle: ""
        },
        {
            title: "Event",
            sectionTitle: "",
            sectionSubTitle: "",
            navbarTitle: ""
        },
        {
            title: "Video",
            sectionTitle: "",
            sectionSubTitle: "",
            navbarTitle: ""
        },
        {
            title: "People",
            sectionTitle: "",
            sectionSubTitle: "",
            navbarTitle: ""
        },
        {
            title: "Gallery",
            sectionTitle: "",
            sectionSubTitle: "",
            navbarTitle: ""
        }
    ]

    return titles;
}